import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

const style = { color: '#0891B2', fillColor: '#06B6D4', fillOpacity: 0.22, weight: 3 };
export const ZoneDrawing = ({ initialGeometry, mode, onChange, onDrawn }) => {
  const map = useMap();
  const layer = useRef(null);
  const initial = useRef(initialGeometry);
  const callbacks = useRef({ onChange, onDrawn });
  callbacks.current = { onChange, onDrawn };
  useEffect(() => {
    map.pm.setLang('es');
    const changed = () => {
      if (layer.current) callbacks.current.onChange(layer.current.toGeoJSON(false).geometry);
    };
    const label = () => {
      layer.current?.getElement()?.setAttribute('data-testid', 'zone-draft-polygon');
      const markers = map.getContainer().querySelectorAll('.marker-icon:not([data-testid])');
      markers.forEach((el, i) => el.setAttribute('data-testid', `zone-vertex-${i}`));
    };
    const bind = polygon => {
      layer.current = polygon;
      polygon.setStyle(style);
      polygon.on('pm:edit pm:vertexadded pm:vertexremoved pm:markerdragend', changed);
      polygon.on('pm:enable', label);
      label();
    };
    if (initial.current) {
      const coordinates = initial.current.coordinates.map(r => r.map(([lon, lat]) => [lat, lon]));
      const polygon = L.polygon(coordinates, style).addTo(map);
      bind(polygon);
      map.fitBounds(polygon.getBounds().pad(0.3), { maxZoom: 17 });
    }
    const created = e => {
      if (e.shape !== 'Polygon') return;
      if (layer.current) map.removeLayer(layer.current);
      bind(e.layer);
      changed();
      callbacks.current.onDrawn();
    };
    map.on('pm:create', created);
    return () => {
      map.pm.disableDraw();
      map.off('pm:create', created);
      if (layer.current) { layer.current.pm?.disable(); map.removeLayer(layer.current); layer.current = null; }
    };
  }, [map]);
  useEffect(() => {
    map.pm.disableDraw();
    layer.current?.pm?.disable();
    if (mode === 'draw') map.pm.enableDraw('Polygon', { allowSelfIntersection: false, snappable: false, pathOptions: style, templineStyle: style, hintlineStyle: style });
    if (mode === 'edit') layer.current?.pm?.enable({ allowSelfIntersection: false, snappable: false });
  }, [map, mode]);
  return null;
};